import '../sass/text-cards.scss';

import consultAnimationWhiteData from '../../../../assets/lottie/service-consult-white.json';
import designAnimationWhiteData from '../../../../assets/lottie/service-design-white.json';
import integrateAnimationWhiteData from '../../../../assets/lottie/service-integrate-white.json';
import supportAnimationWhiteData from '../../../../assets/lottie/service-support-white.json';
import consultAnimationBlackData from '../../../../assets/lottie/service-consult-black.json';
import designAnimationBlackData from '../../../../assets/lottie/service-design-black.json';
import integrateAnimationBlackData from '../../../../assets/lottie/service-integrate-black.json';
import supportAnimationBlackData from '../../../../assets/lottie/service-support-black.json';

const serviceAnimations = {
    'consultWhite': consultAnimationWhiteData,
    'designWhite': designAnimationWhiteData,
    'integrateWhite': integrateAnimationWhiteData,
    'supportWhite': supportAnimationWhiteData,
    'consultBlack': consultAnimationBlackData,
    'designBlack': designAnimationBlackData,
    'integrateBlack': integrateAnimationBlackData,
    'supportBlack': supportAnimationBlackData,
};

(() => {
    const lottieScript = document.querySelector('#boomspace-theme-lottie-js');
    const $blocks = document.querySelectorAll('.text-cards');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $columns = $block.querySelectorAll('.text-cards__column');

        const initIconAnimation = () => {
            if (!$columns) return;

            $columns.forEach($column => {
                let hoverAnimationPlaying = true;

                const $card = $column.querySelector('.text-cards__card');
                const $serviceIcon = $column.querySelector('.text-cards__card-icon-inner');

                const { serviceIcon } = $serviceIcon.dataset;

                if (!serviceIcon || !serviceAnimations[serviceIcon]) return;

                const iconAnimation = lottie.loadAnimation({
                    container: $serviceIcon,
                    renderer: 'canvas',
                    animationData: serviceAnimations[serviceIcon],
                    initialSegment: [0, 26],
                    loop: false,
                    autoplay: false,
                });

                const playAnimation = () => {
                    iconAnimation.goToAndStop(0);

                    setTimeout(() => {
                        iconAnimation.goToAndPlay(0);
                    }, 600);
                };

                if ($column.classList.contains('is-on-screen')) {
                    playAnimation();
                }

                iconAnimation.addEventListener('complete', () => {
                    hoverAnimationPlaying = false;
                });

                $column.addEventListener('onScreen', () => {
                    playAnimation();
                });

                $card.addEventListener('mouseenter', () => {
                    if (hoverAnimationPlaying) return;

                    iconAnimation.playSegments([[80, 124], [0, 26]]);

                    hoverAnimationPlaying = true;
                });
            });
        };

        if (lottie) {
            initIconAnimation();
        } else {
            lottieScript.addEventListener('load', () => {
                initIconAnimation();
            });
        }
    });
})();
